import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { BankAccountModel, DistributionPreferenceModel } from "../api/models";
import { HiddenText } from "../components/common/HiddenText/HiddenText";
import { addressToString } from "./addresses";
import { formatMoney } from "./locale";

function bankAccountValue(bankAccount: BankAccountModel | null | undefined) {
  return (
    <>
      {bankAccount && (
        <>
          {" "}
          ({bankAccount.accountType})
          {bankAccount.nickname && (
            <div data-private>{bankAccount.nickname}</div>
          )}
          {/*bankAccount.name && <div>{bankAccount.name}</div>*/}
          {bankAccount.routingNumber && (
            <Flex>
              <Box mr="2">Routing number</Box>
              <HiddenText
                data-private
                value={bankAccount.routingNumber}
                showLast={3}
              />
            </Flex>
          )}
          {bankAccount.accountNumber && (
            <Flex>
              <Box mr="2">Account number</Box>
              <HiddenText
                data-private
                value={bankAccount.accountNumber}
                showLast={3}
              />
            </Flex>
          )}
        </>
      )}
    </>
  );
}

function splitDistributionValue(
  dP: DistributionPreferenceModel,
  index: number,
) {
  let content = null;
  const methodNameKey = `method${index}` as keyof DistributionPreferenceModel;
  switch (dP[methodNameKey]) {
    case "Bank Transfer":
      content = (
        <>
          Bank transfer
          {bankAccountValue(
            dP[
              `bankAccount${
                index === 1 ? "" : index
              }` as keyof DistributionPreferenceModel
            ] as BankAccountModel,
          )}
        </>
      );
      break;
    case "Check": {
      const a = dP.distributionAddress || {};
      content = (
        <>
          Check mailed to {(dP.addressType || "").toLowerCase()}:
          <div data-private>{addressToString(a)}</div>
        </>
      );
      break;
    }
    default:
      content = dP[methodNameKey];
  }

  const methodValueKey =
    `method${index}Value` as keyof DistributionPreferenceModel;

  const methodValue = dP[methodValueKey];

  return (
    <>
      {methodValue && (
        <div>
          <strong>
            {dP.methodType === "Amount" &&
              (methodValue > 0 ? (
                <>${formatMoney(methodValue as string)}</>
              ) : (
                `Method ${index}`
              ))}
            {dP.methodType === "Percent" &&
              (methodValue > 0 ? <>{methodValue}%</> : `Method ${index}`)}
          </strong>
        </div>
      )}
      {content}
    </>
  );
}

export function distributionPreferenceValue(
  dP?: DistributionPreferenceModel | null,
): React.ReactNode | string {
  if (!dP) return;

  switch (dP.distributionMethod) {
    case "Reinvest":
      return "Reinvest";
    case "Bank Transfer":
      return (
        <>
          Bank transfer
          {bankAccountValue(dP.bankAccount)}
        </>
      );
    case "Check": {
      const a = dP.distributionAddress || {};
      return (
        <>
          Check mailed to {(dP.addressType || "").toLowerCase()}:
          <div data-private>{addressToString(a)}</div>
        </>
      );
    }
    case "Split Distribution":
      return (
        <>
          Split Distribution
          <Box mt={4}>
            <Box mb={2}>{splitDistributionValue(dP, 1)}</Box>
            <Box>{splitDistributionValue(dP, 2)}</Box>
          </Box>
        </>
      );
    default:
      return dP.distributionMethod;
  }
}
